<template>
  <hm-content ref="hmcontent">
    <div class="table-panel flex flex-between">
      <el-radio-group
        v-model="commissionSelect"
        size="small"
        @change="switchTab"
    >
      <el-radio-button label="base">基础佣金</el-radio-button>
      <el-radio-button label="fixed">定向佣金</el-radio-button>
    </el-radio-group>
    </div>
    <div class="table-panel flex flex-between">
      <div>
        <el-button class="mr10" type="primary" size="small" @click="add"
          >新增返佣</el-button
        >
      </div>
      <div class="text-right">
        <el-input
          clearable
          v-model.trim="searchCondition.commissionLabel"
          placeholder="请输入新增标签"
          size="small"
          class="ipt mr10 mb10"
        ></el-input>
        <el-input
          clearable
          v-model.trim="searchCondition.keyword"
          :placeholder="placeholder"
          size="small"
          style="width: 300px"
          class="ipt mr10 mb10"
        >
          <el-select
            slot="prepend"
            style="width: 100px"
            v-model="searchCondition.queryType"
            size="small"
            @change="selectQueryType"
          >
            <el-option label="商品货号" value="goodsSn"></el-option>
            <el-option label="商品条码" value="specBarcode"></el-option>
            <el-option label="商品名称" value="wxshopSpuName"></el-option>
          </el-select>
        </el-input>
        <!-- <el-input
          clearable
          style="width: 200px"
          v-model.trim="searchCondition.keyword"
          placeholder="请输入货号/条码/商品名称"
          size="small"
          class="ipt mr10"
        ></el-input> -->
        <el-cascader
          v-model="searchCondition.wxshopCategoryId"
          :show-all-levels="false"
          size="small"
          class="mr10 mb10 goods-classify"
          :props="categoryFunc"
          clearable
          placeholder="请选择微店商品分类"
        ></el-cascader>
        <el-cascader
          v-model="searchCondition.attributeId"
          placeholder="请选择辅助属性"
          :show-all-levels="false"
          size="small"
          class="mr10 mb10"
          :props="attributeFunc"
          clearable
        ></el-cascader>
        <el-input
          clearable
          style="width: 100px"
          type="number"
          v-model.trim="searchCondition.minPrice"
          placeholder="最低零售价"
          size="small"
          class="ipt mr10 mb10"
        ></el-input>
        <el-input
          clearable
          type="number"
          style="width: 100px"
          v-model.trim="searchCondition.maxPrice"
          placeholder="最高零售价"
          size="small"
          class="ipt mr10 mb10"
        ></el-input>
        <el-select
          clearable
          v-model="searchCondition.shareGoodsState"
          placeholder="请选择状态"
          size="small"
          class="mr10 mb10 flex-1"
          filterable
        >
          <el-option label="正常" value="normal"></el-option>
          <el-option label="过期" value="overdue"></el-option>
          <el-option label="结束" value="end"></el-option>
        </el-select>
        <el-date-picker
          v-model="searchCondition.applyDate"
          type="datetimerange"
          align="right"
          start-placeholder="请选择返佣开始时段"
          end-placeholder="请选择返佣结束时段"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          size="small"
          class="mr10 mb10 time"
        ></el-date-picker>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button type="info" size="small" @click="searchCondition = {}"
          >重置</el-button
        >
        <el-button
          type="success"
          size="small"
          @click="output('queryAllList', '分销商品')"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>

    <div class="flex flex-between item-center mb10">
      <el-radio-group
        v-model="searchCondition.timeStatus"
        size="small"
        @change="switchTab"
      >
        <el-radio-button label="all">全部</el-radio-button>
        <el-radio-button label="running">进行中</el-radio-button>
        <el-radio-button label="notStart">未开始</el-radio-button>
        <el-radio-button label="ending">已结束</el-radio-button>
      </el-radio-group>
      <div class="mr10" style="marginbottom: -20px">
        <span @click="batchSetting" class="pointer">
          <!-- <span class="delete-icon hmicon icon-shanchu "></span> -->
          批量结束
        </span>
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
        @selection-change="getChecked"
        v-if="resetForm"
      >
        <el-table-column
          type="selection"
          :selectable="checkboxT"
        ></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="wxshopSpuName"
          label="商品名称"
        >
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="groupName"
            label="分销分组"
            v-if="commissionSelect === 'fixed' "
        >
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="commissionLabel"
            :label="commissionSelect === 'base' ? '新增标签' : '活动名称' "
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsSn"
          label="商品货号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="wxshopPrice"
          label="零售价"
        >
          <template slot-scope="scope">
            <span class="primary">{{ scope.row.wxshopPrice }}元</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="commissionPriorityLevel"
          label="返佣优先级"
          v-if="commissionSelect === 'base' "
        >
          <template slot-scope="scope">
            <div>
              {{
                scope.row.commissionPriorityLevel === "common"
                  ? "普通返佣"
                  : "优先返佣"
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="创建日期"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="commissionTime"
          label="返佣时段"
          width="300"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.commissionStartTime }}至{{
                scope.row.commissionEndTime
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="commissionType"
          header-align="center"
          align="center"
          label="返佣方式"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.commissionType === 'fixedReturn'">
              固定返佣
            </div>
            <div v-else>比例返佣</div>
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="commissionValue"
          label="分销会员佣金"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.commissionValue
              }}{{ scope.row.commissionType === "fixedReturn" ? "元" : "%" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="agentDiscountValue"
          label="代理奖励折扣"
          v-if="commissionSelect === 'base' "
        >
          <template slot-scope="scope">
            <div>{{ scope.row.agentDiscountValue }}%</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shareGoodsState"
          label="状态"
        >
          <template slot-scope="scope">
            <span class="success" v-if="scope.row.shareGoodsState == '正常'">{{ scope.row.shareGoodsState }}</span>
            <span class="gray" v-else>{{ scope.row.shareGoodsState }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                v-if="searchCondition.timeStatus !== 'ending'"
                size="small"
                :disabled="scope.row.enabledState === 'no'"
                @click="end(scope.row)"
                :class="[scope.row.enabledState === 'no' ? 'gray' : 'danger']"
                type="text"
                >结束</el-button
              >
            </div>
          </template>
        </el-table-column>

        <template slot="empty">
          <div class="empty">
            <img class="img_no" src="../../assets/n001.jpg" alt="" />
            <p class="empty_tex">请设置查询条件后查询</p>
          </div>
        </template>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="新增基础返佣"
      width="1400px"
      :visible.sync="dialogVisible"
      :before-close="cancel"
      @close="dialogVisible = false"
    >
      <el-dialog
        width="1200px"
        :title="errTitle"
        :visible.sync="innerVisible"
        append-to-body
      >
        <el-table
          stripe
          border
          ref="table"
          :data="errGoodList"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="wxshopSpuName"
            label="商品名称"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsSn"
            label="商品货号"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="wxshopPrice"
            label="零售价"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="commissionStartTime"
            label="本次设置返佣开始时间"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="commissionEndTime"
            label="本次设置返佣结束时间"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="commissionStartTimeOld"
            label="已有设置返佣开始时间"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="commissionEndTimeOld"
            label="已有设置返佣结束时间"
          >
          </el-table-column>
        </el-table>
      </el-dialog>
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="设置标签" prop="commissionLabel">
          <el-input
            v-model.trim="ruleForm.commissionLabel"
            maxlength="20"
            size="small"
            placeholder="请输入标签"
          ></el-input>
          <div class="form-item-tip">
            设置标签用作批量查询同一批次设置的返佣商品，命名不可重复
          </div>
        </el-form-item>
        <el-form-item label="返佣优先级" prop="commissionPriorityLevel">
          <el-select
            placeholder="请选择返佣优先级"
            v-model="ruleForm.commissionPriorityLevel"
            size="small"
          >
            <el-option label="普通返佣" value="common"></el-option>
            <el-option label="优先返佣" value="first"></el-option>
          </el-select>
        </el-form-item>

        <div class="table">
          <div class="flex flex-between">
            <div class="title">返佣商品列表</div>
            <div class="flex flex-end">
              <div @click="outputExcel" class="delete mr20 pointer">
                <span class="delete-icon hmicon icon-daochu"></span>
                导出模板
              </div>
              <div class="delete mr20 pointer open-file">
                <span class="delete-icon hmicon icon-daoru"></span>
                导入商品
                <input
                  type="file"
                  @change="importf"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
              </div>
            </div>
          </div>
          <div class="flex flex-end form-red">
            建议单次导入商品请不要超过30条，否则可能导入系统卡顿或者连接超时报错。
          </div>
          <el-table
            stripe
            border
            ref="table"
            :data="distributionGoodList"
            style="width: 100%"
            id="table"
            size="small"
          >
            <el-table-column
              type="index"
              label="序号"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="wxshopSpuName"
              label="商品名称"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsSn"
              label="商品货号"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="wxshopPrice"
              label="零售价"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="commissionStartTime"
              label="返佣开始时间"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="commissionEndTime"
              label="返佣结束时间"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="commissionType"
              label="返佣方式"
              width="300"
            >
              <template slot-scope="scope">
                <el-radio-group
                  v-model="scope.row.commissionType"
                  class="margin-right"
                  size="small"
                >
                  <el-radio label="ratioReturn">比例返佣</el-radio>
                  <el-radio label="fixedReturn">固定返佣</el-radio>
                </el-radio-group>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="commissionValue"
              label="分销会员佣金"
            >
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-input
                    v-model="scope.row.commissionValue"
                    @input="filterGt0OrFixed2('commissionValue', scope.$index)"
                    clearable
                    style="width: 130px"
                    placeholder="分销佣金"
                    size="small"
                    class="ipt mr10"
                  ></el-input>
                  <div class="flex flex-center item-center">
                    {{
                      scope.row.commissionType === "ratioReturn" ? "%" : "元"
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="agentDiscountValue"
              header-align="center"
              align="center"
              label="代理奖励折扣"
            >
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-input
                    v-model="scope.row.agentDiscountValue"
                    @input="
                      filterGt0OrFixed2('agentDiscountValue', scope.$index)
                    "
                    clearable
                    style="width: 130px"
                    placeholder="奖励折扣"
                    size="small"
                    class="ipt mr10"
                  ></el-input>
                  <div class="flex flex-center item-center">%</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-button
                    size="small"
                    class="blue"
                    type="text"
                    @click="remove(scope.$index)"
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center mt20">
        <el-button @click="submitForm('ruleForm')" size="small" type="primary">
          确 认</el-button
        >
        <el-button size="small" @click="cancel">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
        :close-on-click-modal="false"
        title="新增定向返佣"
        width="1400px"
        :visible.sync="fixedCommissionVisible"
        :before-close="cancel"
        @close="fixedCommissionVisible = false"
    >
      <el-dialog
          width="1200px"
          :title="errTitle"
          :visible.sync="innerVisible"
          append-to-body
      >
        <el-table
            stripe
            border
            ref="table"
            :data="errGoodList"
            style="width: 100%"
            id="table"
            size="small"
        >
          <el-table-column
              type="index"
              label="序号"
              header-align="center"
              align="center"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="wxshopSpuName"
              label="商品名称"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="goodsSn"
              label="商品货号"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="wxshopPrice"
              label="零售价"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="commissionStartTime"
              label="本次设置返佣开始时间"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="commissionEndTime"
              label="本次设置返佣结束时间"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="commissionStartTimeOld"
              label="已有设置返佣开始时间"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="commissionEndTimeOld"
              label="已有设置返佣结束时间"
          >
          </el-table-column>
        </el-table>
      </el-dialog>
      <el-form
          ref="fixedRuleForm"
          :model="fixedRuleForm"
          :rules="fixedRules"
          label-width="100px"
      >
        <el-form-item label="活动名称" prop="commissionLabel">
          <el-input
              v-model.trim="fixedRuleForm.commissionLabel"
              maxlength="20"
              size="small"
              placeholder="请输入活动名称"
          ></el-input>
          <div class="form-item-tip">
            命名不可重复
          </div>
        </el-form-item>
        <el-form-item label="分组名称" prop="groupId">
          <el-select
              v-model="fixedRuleForm.groupId"
              value-key="id"
              size="small"
              v-if="groupList"
              filterable
              clearable
              placeholder="请选择分组"
          >
            <el-option
                v-for="(item, i) in groupList"
                :key="i"
                :label="item.groupName"
                :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="返佣开始时间：">
          <el-date-picker
              v-model="fixedRuleForm.commissionStartTime"
              type="datetime"
              placeholder="请选择返佣开始时间"
              align="right"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="返佣结束时间：">
          <el-date-picker
              v-model="fixedRuleForm.commissionEndTime"
              type="datetime"
              placeholder="请选择返佣结束时间"
              align="right"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
          ></el-date-picker>
        </el-form-item>
        <div class="table">
          <div class="flex flex-between">
            <div class="title">返佣商品列表</div>
            <div class="flex flex-end">
              <div @click="outputExcelByFixed" class="delete mr20 pointer">
                <span class="delete-icon hmicon icon-daochu"></span>
                导出模板
              </div>
              <div class="delete mr20 pointer open-file">
                <span class="delete-icon hmicon icon-daoru"></span>
                导入商品
                <input
                    type="file"
                    @change="importByFixed"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
              </div>
            </div>
          </div>
          <div class="flex flex-end form-red">
            建议单次导入商品请不要超过30条，否则可能导入系统卡顿或者连接超时报错。
          </div>
          <el-table
              stripe
              border
              ref="table"
              :data="distributionGoodList"
              style="width: 100%"
              id="table"
              size="small"
          >
            <el-table-column
                type="index"
                label="序号"
                header-align="center"
                align="center"
            ></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="wxshopSpuName"
                label="商品名称"
            >
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="goodsSn"
                label="商品货号"
            >
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="wxshopPrice"
                label="零售价"
            >
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="commissionType"
                label="返佣方式"
                width="300"
            >
              <template slot-scope="scope">
                <el-radio-group
                    v-model="scope.row.commissionType"
                    class="margin-right"
                    size="small"
                >
                  <el-radio label="ratioReturn">比例返佣</el-radio>
                  <el-radio label="fixedReturn">固定返佣</el-radio>
                </el-radio-group>
              </template>
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="commissionValue"
                label="分销会员佣金"
            >
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-input
                      v-model="scope.row.commissionValue"
                      @input="filterGt0OrFixed2('commissionValue', scope.$index)"
                      clearable
                      style="width: 130px"
                      placeholder="分销佣金"
                      size="small"
                      class="ipt mr10"
                  ></el-input>
                  <div class="flex flex-center item-center">
                    {{
                      scope.row.commissionType === "ratioReturn" ? "%" : "元"
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-button
                      size="small"
                      class="blue"
                      type="text"
                      @click="remove(scope.$index)"
                  >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center mt20">
        <el-button @click="submitFixedForm('fixedRuleForm')" size="small" type="primary">
          确 认</el-button
        >
        <el-button size="small" @click="cancel">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="errValidGoods" width="30%" title="提示">
      <div>
        <div>
          您有
          <span class="error">{{ errInputResult.length }}</span
          >条数据有误未导入
        </div>
        <el-table :data="errInputResult" border class="small-table">
          <el-table-column prop="goodsSn" label="错误货号"></el-table-column>
          <!-- <el-table-column prop="mobile" label="手机号"></el-table-column> -->
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="incompletelyVisible"
      width="1000"
      title="导入数据有未填写项"
    >
      <div class="flex flex-end form-red">
        请填写完整商品信息，或者删除（选中需删除行点击右键选择删除）空白行
      </div>
      <div>
        <el-table
          style="width: 100%"
          id="table"
          height="400"
          size="small"
          :data="incompletelyGoods"
          stripe
          border
          class="small-table"
        >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="goodsSn"
            header-align="center"
            align="center"
            label="货号"
          >
          </el-table-column>
          <el-table-column
            prop="goodsSn"
            header-align="center"
            align="center"
            label="返佣开始时间"
          >
          </el-table-column>
          <el-table-column
            prop="goodsSn"
            header-align="center"
            align="center"
            label="返佣结束时间"
          >
          </el-table-column>
          <el-table-column
            prop="goodsSn"
            header-align="center"
            align="center"
            label="返佣方式"
          >
          </el-table-column>
          <el-table-column
            prop="goodsSn"
            header-align="center"
            align="center"
            label="返销会员佣金（%）"
          >
          </el-table-column>
          <el-table-column
            prop="goodsSn"
            header-align="center"
            align="center"
            label="代理奖励折扣（%）"
          >
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import XLSX from "xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {},
  data() {
    return {
      incompletelyVisible: false,
      incompletelyGoods: [],
      errTitle: "",
      innerVisible: false,
      errValidGoods: false,
      errInputResult: [],
      distributionGoodList: [],
      ruleForm: {
        commissionLabel: "",
        commissionPriorityLevel: "",
        groupId: "",
        commissionStartTime: "",
        commissionEndTime: "",
      },
      fixedRuleForm: {
        commissionLabel: "",
        commissionPriorityLevel: "",
        groupId: "",
        commissionStartTime: "",
        commissionEndTime: "",
        groupName: "",
      },
      rules: {
        commissionLabel: {
          required: true,
          message: "请输入标签",
          trigger: "change",
        },
        commissionPriorityLevel: {
          required: true,
          message: "请选择返佣优先级",
          trigger: "change",
        },
        groupId: {
          required: true,
          message: "请选择分销分组",
          trigger: "change",
        }
      },
      fixedRules: {
        commissionLabel: {
          required: true,
          message: "请输入活动名称",
          trigger: "change",
        },
        groupId: {
          required: true,
          message: "请选择分销分组",
          trigger: "change",
        },
        commissionStartTime: {
          required: true,
          message: "请选择分佣开始时间",
          trigger: "change",
        },
        commissionEndTime: {
          required: true,
          message: "请选择分佣结束时间",
          trigger: "change",
        }
      },
      resetForm: true,
      dialogVisible: false,
      fixedCommissionVisible: false,
      isOutputing: false,
      currentPage: 1,
      pageSize: 10,
      list: [],
      total: 0,
      placeholder: "请输入商品货号",
      commissionSelect: "base",
      searchCondition: {
        queryType: "goodsSn",
        timeStatus: "all",
      },
      categoryFunc: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: 1,
              })
              .then((res) => {
                res.result.forEach((v) => {
                  v.value = v.wxshopCategoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: level + 1,
                wxshopParentCategoryId: data.wxshopCategoryId,
              })
              .then((res) => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach((v) => {
                    v.value = v.wxshopCategoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        },
      },
      attributeFunc: {
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level } = node;
          if (level === 0) {
            this.$store.dispatch("queryAttrListByAddGoods").then((res) => {
              res.result.forEach((v) => {
                v.value = v.valueId;
                v.label = v.attributeValue;
              });
              resolve(res.result);
            });
          } else {
            let params = {};
            if (level === 1) {
              params = {
                typeId: node.data.valueId,
              };
            } else {
              params = {
                attributeId: node.data.valueId,
              };
            }
            this.$store
              .dispatch("queryAttrListByAddGoods", params)
              .then((res) => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach((v) => {
                    v.value = v.valueId;
                    v.label = v.attributeValue;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        },
      },
      ids: [],
      errGoodList: [],
      groupList: [],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryAllGroup();
  },
  methods: {
    async queryAllGroup() {
      let params = {
        pageNo: 1,
        pageSize: 99999,
      };
      const { result } = await this.$store.dispatch(
          "shareGroupList",
          params
      );
      const { records, total } = result;
      this.groupList = records;
    },
    batchSetting() {
      if (this.ids.length) {
        let say = "结束已选" + this.ids.length + "条数据";
        this.$confirm(say, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let params = { ids: this.ids };
          this.$store.dispatch("batchEditRangeFlowNew", params).then((res) => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success",
              });
              this.queryList();
            }
          });
        });
      } else {
        this.$message({
          message: "请选择要结束的商品",
          type: "warning",
        });
      }
    },
    checkboxT(row) {
      if (
        row.enabledState === "no" ||
        this.searchCondition.timeStatus === "ending"
      ) {
        return false;
      } else {
        return true;
      }
    },
    getChecked(selection) {
      this.ids = selection.map((v) => v.id);
    },
    cancel() {
      if (this.commissionSelect === 'base') {
        this.dialogVisible = false;
      } else if (this.commissionSelect === 'fixed') {
        this.fixedCommissionVisible = false;
      }

      this.rest();
    },
    selectQueryType(queryType) {
      if (queryType === "goodsSn") {
        this.placeholder = "请输入商品货号";
      } else if (queryType === "specBarcode") {
        this.placeholder = "请输入商品条码";
      } else if (queryType === "wxshopSpuName") {
        this.placeholder = "请输入商品名称";
      }
    },
    remove(i) {
      this.distributionGoodList.splice(i, 1);
    },
    rest() {
      setTimeout(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.resetFields();
        }
        this.distributionGoodList = [];
        this.errInputResult = [];
      }, 0);
    },
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        if (this.distributionGoodList.length > 0) {
          let flag = true;
          this.distributionGoodList.forEach((v) => {
            if (v.commissionValue === "" || v.agentDiscountValue === "") {
              flag = false;
            }
          });
          if (flag) {
            let params = this.ruleForm;
            params.flowNewModels = this.distributionGoodList;
            const { code, result } = await this.$store.dispatch(
              "shareSkuDateRangeFlowNew",
              params
            );
            if (code === "0") {
              if (result) {
                this.errTitle = "重复返佣时段商品";
                this.innerVisible = true;
                this.errGoodList = result;
              }
              this.$message({
                type: "success",
                message: "操作成功",
              });
              setTimeout(() => {
                this.rest();
              }, 0);
              this.dialogVisible = false;
              this.queryList();
            }
          } else {
            this.$message({
              type: "warning",
              message: "请填写完整商品信息",
            });
          }
        } else {
          this.$message({
            type: "warning",
            message: "请选择返佣商品",
          });
        }
      }
    },
    async submitFixedForm(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        if (this.distributionGoodList.length > 0) {
          let flag = true;
          this.distributionGoodList.forEach((v) => {
            if (v.commissionValue === "" || v.agentDiscountValue === "") {
              flag = false;
            }
          });
          if (flag) {
            let params = this.fixedRuleForm;
            params.flowNewModels = this.distributionGoodList;
            let groupName = "";
            this.groupList.filter(v=>{
              console.log(v)
              if (params.groupId == v.id) {
                groupName = v.groupName;
              }
            })
            params.groupName = groupName;
            const { code, result } = await this.$store.dispatch(
                "addFixedShareRule",
                params
            );
            if (code === "0") {
              if (result) {
                this.errTitle = "重复返佣时段商品";
                this.innerVisible = true;
                this.errGoodList = result;
              }
              this.$message({
                type: "success",
                message: "操作成功",
              });
              setTimeout(() => {
                this.rest();
              }, 0);
              this.fixedCommissionVisible = false;
              this.queryList();
            }
          } else {
            this.$message({
              type: "warning",
              message: "请填写完整商品信息",
            });
          }
        } else {
          this.$message({
            type: "warning",
            message: "请选择返佣商品",
          });
        }
      }
    },
    add() {
      console.log("this.searchCondition.commissionSelect:", this.commissionSelect);
      if (this.commissionSelect === "base") {
        this.dialogVisible = true;
      } else {
        this.fixedCommissionVisible = true;
      }
    },
    switchTab() {
      this.resetForm = false
      this.$nextTick(()=>{
        this.resetForm = true;
      })
      this.currentPage = 1;
      console.log(this.commissionSelect === 'base');
      this.queryList();
    },
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        commissionSelect: this.commissionSelect,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.wxshopCategoryId = this.isArray(
        searchCondition.wxshopCategoryId
      )
        ? searchCondition.wxshopCategoryId[
            searchCondition.wxshopCategoryId.length - 1
          ]
        : searchCondition.wxshopCategoryId;

      searchCondition.attributeId = this.isArray(searchCondition.attributeId)
        ? searchCondition.attributeId[searchCondition.attributeId.length - 1]
        : "";

      searchCondition.queryStartTime = this.isArray(
        searchCondition.applyDate
      )
        ? searchCondition.applyDate[0]
        : "";
      searchCondition.queryEndTime = this.isArray(
        searchCondition.applyDate
      )
        ? searchCondition.applyDate[1]
        : "";

      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryShareSkuDateRangeFlowNewList",
        params
      );
      const { records, total } = result;
      records.forEach((v) => {
        v.agentDiscountValue = (v.agentDiscountValue * 100).toFixed(4);

        if (v.commissionType === "ratioReturn") {
          v.commissionValue = (v.commissionValue * 100).toFixed(4);
        } else {
          v.commissionValue = v.commissionValue.toFixed(4);
        }
      });
      this.list = records;
      this.total = total;
    },
    async queryAllList() {
      let params = {
        pageNo: 1,
        pageSize: 99999,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.wxshopCategoryId = this.isArray(
        searchCondition.wxshopCategoryId
      )
        ? searchCondition.wxshopCategoryId[
            searchCondition.wxshopCategoryId.length - 1
          ]
        : searchCondition.wxshopCategoryId;

      searchCondition.attributeId = this.isArray(searchCondition.attributeId)
        ? searchCondition.attributeId[searchCondition.attributeId.length - 1]
        : "";

      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryAllShareSkuDateRangeFlowNewList",
        params
      );
      const { records } = result;
      records.forEach((v) => {
        v.agentDiscountValue = v.agentDiscountValue * 100;
        if (v.commissionType === "ratioReturn") {
          v.commissionValue = v.commissionValue * 100;
        }
      });
      return records;
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    end(row) {
      this.$confirm("是否确认结束？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store
            .dispatch("editShareSkuDateRangeFlowNew", { id: row.id })
            .then((res) => {
              if (res.code === "0") {
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
                this.queryList();
              }
            });
        })
        .catch(() => {});
    },
    // 导出excel
    output() {
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.wxshopCategoryId = this.isArray(
        searchCondition.wxshopCategoryId
      )
        ? searchCondition.wxshopCategoryId[
            searchCondition.wxshopCategoryId.length - 1
          ]
        : searchCondition.wxshopCategoryId;

      searchCondition.attributeId = this.isArray(searchCondition.attributeId)
        ? searchCondition.attributeId[searchCondition.attributeId.length - 1]
        : "";
      this.$store.dispatch("shareSkuDateRangeExport", searchCondition);
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success",
        });
        this.$refs.hmcontent.flag = false;
      }, 0);
      // require.ensure([], () => {
      //   const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
      //   this.isOutputing = true;
      //   const func = this[funcName];
      //   func()
      //     .then(res => {
      //       const list = res;
      //       list.forEach(v => {
      //         v.commissionType =
      //           v.commissionType === "fixedReturn" ? "固定返佣" : "比例返佣";
      //         v.commissionValue =
      //           v.commissionType === "固定返佣"
      //             ? v.commissionValue + "元"
      //             : v.commissionValue + "%";
      //         v.commissionPriorityLevel =
      //           v.commissionPriorityLevel === "common"
      //             ? "普通返佣"
      //             : "优先返佣";
      //         v.agentDiscountValue = v.agentDiscountValue + "%";
      //         v.commissionTime = `${v.commissionStartTime}至${
      //           v.commissionEndTime
      //         }`;
      //       });
      //       const tHeader = this.$refs.table.columns
      //         .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
      //         .filter(o => o);
      //       let filterVal = [];
      //       if (list.length > 0) {
      //         filterVal = this.$refs.table.$children
      //           .map(o => o._props.prop)
      //           .filter(o => o);
      //       }
      //       const data = this.formatJson(filterVal, list);
      //       exportJsonToExcel(
      //         tHeader,
      //         data,
      //         title + new Date().toLocaleString()
      //       );
      //       this.isOutputing = false;
      //     })
      //     .catch(() => {
      //       this.isOutputing = false;
      //     });
      // });
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = [
          "商品货号",
          "返佣开始时间(请使用文本格式)",
          "返佣结束时间(请使用文本格式)",
          "返佣方式(固定返佣/比例返佣)",
          "返销会员佣金（%）",
          "代理奖励折扣（%）",
        ];
        const data = [
          ["ABC123", "2020-01-30", "2020-01-31", "固定返佣", "12", "5"],
          ["AXC123", "2020-01-30", "2020-01-31", "比例返佣", "22", "3"],
        ];

        exportJsonToExcel(tHeader, data, "模板");
      });
    },
    //定向返佣导出模板
    outputExcelByFixed() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = [
          "商品货号",
          "返佣方式(固定返佣/比例返佣)",
          "返销会员佣金（%）",
        ];
        const data = [
          ["ABC123", "固定返佣", "12"],
          ["AXC123", "比例返佣", "22"],
        ];

        exportJsonToExcel(tHeader, data, "模板");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    filterGt0OrFixed2(prop, i) {
      // this.distributionGoodList[i][prop] = this.distributionGoodList[i][
      //   prop
      // ].replace(/^(0+)/, ""); //过滤0开头
      this.distributionGoodList[i][prop] = this.distributionGoodList[i][
        prop
      ].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.distributionGoodList[i][prop] = this.distributionGoodList[i][
        prop
      ].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.distributionGoodList[i][prop] = this.distributionGoodList[i][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.distributionGoodList[i][prop] = this.distributionGoodList[i][
        prop
      ].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (
        this.distributionGoodList[i][prop].indexOf(".") < 0 &&
        this.distributionGoodList[i][prop] != ""
      ) {
        //首位是0的话去掉
        this.distributionGoodList[i][prop] = parseFloat(
          this.distributionGoodList[i][prop]
        );
      }
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        const formatResult = [];
        let isValid = true;
        let isRequired = true;
        let goodsSns = [];
        result.forEach((v) => {
          that.incompletelyGoods.push({
            goodsSn: v[0],
            commissionStartTime: v[1],
            commissionEndTime: v[2],
            commissionType: v[3],
            commissionValue: v[4],
            agentDiscountValue: v[5],
          });
          if (!v[0] || !v[1] || !v[2]) {
            isRequired = false;
          } else {
            if (!that.isString(v[1]) || !that.isString(v[2])) {
              isValid = false;
              //   that.errValidGoods = true;
              //   that.errInputResult.push({
              //     name: v[0],
              //     mobile: v[1]
              //   });
            } else {
              goodsSns.push(v[0]);
              formatResult.push({
                goodsSn: v[0] + "",
                commissionStartTime: `${v[1]} 00:00:00`,
                commissionEndTime: `${v[2]} 23:59:59`,
                commissionType:
                  v[3] === "固定返佣" ? "fixedReturn" : "ratioReturn",
                commissionValue: v[4] ? v[4] : "",
                agentDiscountValue: v[5] ? v[5] : "",
              });
            }
          }
        });
        if (isValid && isRequired) {
          let errList = formatResult.filter((item, index, self) => {
            for (let i = index + 1; i < self.length; i++) {
              if (self[i].goodsSn === item.goodsSn) {
                return true;
              }
            }
            return false;
          });

          if (errList.length > 0) {
            that.errValidGoods = true;
            that.errInputResult = errList;
            that.$message({
              message: "导入失败，有重复商品货号！",
              type: "warning",
            });
          } else {
            that.$store
              .dispatch("queryShareGoodsSn", { goodsSns })
              .then((res) => {
                const { code, result } = res;
                if (code === "0") {
                  if (result.resultList.length > 0) {
                    that.distributionGoodList = [];
                    result.resultList.forEach((v) => {
                      formatResult.forEach((item) => {
                        if (v.goodsSn === item.goodsSn) {
                          that.distributionGoodList.push(
                            Object.assign({}, item, v)
                          );
                        }
                      });
                    });
                  }
                  if (result.errGoodsSns.length > 0) {
                    that.errValidGoods = true;
                    that.errInputResult = [];
                    result.errGoodsSns.forEach((v) => {
                      that.errInputResult.push({ goodsSn: v });
                    });
                  }
                }
              });
          }
        } else {
          if (!isRequired) {
            that.incompletelyVisible = true;
            setTimeout(() => {
              that.$message({
                message: "导入失败，请导入必填商品信息！",
                type: "warning",
              });
            }, 0);
          } else if (!isValid) {
            that.$message({
              message: "导入失败，日期请使用文本格式导入！",
              type: "warning",
            });
          }
        }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    //定向佣金模板导入
    importByFixed(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        console.log("result:::::", result);
        const formatResult = [];
        let isValid = true;
        let isRequired = true;
        let goodsSns = [];
        result.forEach((v) => {
          that.incompletelyGoods.push({
            goodsSn: v[0],
            commissionType: v[1] === "固定返佣" ? "fixedReturn" : "ratioReturn",
            commissionValue: v[2],
          });
          if (!v[0] || !v[1] || !v[2]) {
            isRequired = false;
          } else {
              goodsSns.push(v[0]);
              formatResult.push({
                goodsSn: v[0] + "",
                commissionType:
                    v[1] === "固定返佣" ? "fixedReturn" : "ratioReturn",
                commissionValue: v[2] ? v[2] : ""
              });
          }
        });
        console.log("that.incompletelyGoods:::", that.incompletelyGoods);
        console.log("goodsSns::::", goodsSns);
        console.log("isValid:",isValid);
        console.log("isRequired:",isValid);
        if (isValid && isRequired) {
          let errList = formatResult.filter((item, index, self) => {
            for (let i = index + 1; i < self.length; i++) {
              if (self[i].goodsSn === item.goodsSn) {
                return true;
              }
            }
            return false;
          });

          if (errList.length > 0) {
            that.errValidGoods = true;
            that.errInputResult = errList;
            that.$message({
              message: "导入失败，有重复商品货号！",
              type: "warning",
            });
          } else {
            that.$store
                .dispatch("queryShareGoodsSn", { goodsSns })
                .then((res) => {
                  const { code, result } = res;
                  if (code === "0") {
                    if (result.resultList.length > 0) {
                      that.distributionGoodList = [];
                      result.resultList.forEach((v) => {
                        formatResult.forEach((item) => {
                          if (v.goodsSn === item.goodsSn) {
                            that.distributionGoodList.push(
                                Object.assign({}, item, v)
                            );
                          }
                        });
                      });
                      console.log("that.distributionGoodList：：：：", that.distributionGoodList);
                    }
                    if (result.errGoodsSns.length > 0) {
                      that.errValidGoods = true;
                      that.errInputResult = [];
                      result.errGoodsSns.forEach((v) => {
                        that.errInputResult.push({ goodsSn: v });
                      });
                    }
                  }
                });
          }
        } else {
          if (!isRequired) {
            that.incompletelyVisible = true;
            setTimeout(() => {
              that.$message({
                message: "导入失败，请导入必填商品信息！",
                type: "warning",
              });
            }, 0);
          } else if (!isValid) {
            that.$message({
              message: "导入失败，日期请使用文本格式导入！",
              type: "warning",
            });
          }
        }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    isString(value) {
      return typeof value === "string";
    },
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
  },
};
</script>
<style lang="scss">
.goods-classify {
  width: 200px;
  .el-input {
    width: 200px;
  }
}
</style>
<style lang="scss" scoped>
.empty {
  width: 100%;
  box-sizing: border-box;
  padding-top: 40px;
  .empty_tex {
    font-size: 18px;
    color: #666666;
    height: 40px;
    line-height: 40px;
    margin-bottom: 20px;
    padding: 0;
  }
}

.open-file {
  position: relative;
  overflow: hidden;
}
.open-file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.title {
  color: rgba(34, 34, 34, 1);
  // margin-bottom: 10px;
  &::before {
    display: inline-block;
    margin-right: 10px;
    content: "";
    width: 4px;
    height: 12px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
</style>
